import React, { createContext, useContext, useState, useCallback } from "react";
import { CheckCircle, XCircle, Info, X } from "lucide-react";
import { vibra } from "./preferenzeDispositivo";
const ToastContext = createContext();
const ERRORE_PERMESSI = /insufficient permissions|permission[-_ ]denied/i;
const TESTO_PERMESSI = "Operazione non consentita: questa sezione è in sola lettura (piano attuale, oppure Partita IVA dell'azienda ancora da inserire), o il tuo ruolo non ha questo permesso. I dati restano consultabili.";
export function useToast() { return useContext(ToastContext); }
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const addToast = useCallback((message, type = "info", durataMs = 4500) => {
    // Scrittura rifiutata dalle Regole Firestore (modulo non incluso nel piano, sola lettura
    // a fine prova, oppure permessi del ruolo): al posto del messaggio tecnico in inglese
    // ("Missing or insufficient permissions") un testo comprensibile.
    if (typeof message === "string" && ERRORE_PERMESSI.test(message)) { message = TESTO_PERMESSI; type = "error"; durataMs = Math.max(durataMs, 7000); }
    const id = Date.now() + Math.random();
    // conferma anche al tatto sul telefono (utils/preferenzeDispositivo.js)
    if (type === "success") vibra("ok"); else if (type === "error") vibra("errore");
    setToasts(p => [...p, { id, message, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), durataMs);
  }, []);
  // Salvataggi falliti che la pagina non mostra (errore solo in console): stesso avviso.
  React.useEffect(() => {
    const h = (ev) => {
      const e = ev?.reason; const t = `${e?.code || ""} ${e?.message || ""}`;
      if (ERRORE_PERMESSI.test(t)) addToast(TESTO_PERMESSI, "error", 7000);
    };
    window.addEventListener("unhandledrejection", h);
    return () => window.removeEventListener("unhandledrejection", h);
  }, [addToast]);
  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast ${t.type === "viola" ? "info" : t.type}`}
            style={t.type === "viola" ? { background:"#7c3aed", color:"#fff", borderColor:"#7c3aed" } : undefined}>
            {t.type === "success" && <CheckCircle size={15}/>}
            {t.type === "viola" && <Info size={15}/>}
            {t.type === "error" && <XCircle size={15}/>}
            {t.type === "info" && <Info size={15}/>}
            <span style={{ flex: 1 }}>{t.message}</span>
            <button onClick={() => setToasts(p => p.filter(x => x.id !== t.id))}
              style={{ background:"none", border:"none", cursor:"pointer", color:"inherit", opacity:0.7, padding:0 }}>
              <X size={13}/>
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
